import { ComponentChild, h } from 'preact'
import Panel from '../panel'

export const FeaturedTopicsModeratorTags = ({ dragHandle, switcher }: {dragHandle: ComponentChild, switcher: ComponentChild}) => {
  return (
    <Panel customClass='homepage-widget' title={<div className='panel-title-with-switch'>
      <div className='homepage-reorderable-panel-title'>
        { dragHandle }
        <span>Featured topics (moderator tags)</span>
      </div>
      {switcher}
    </div>} />
  )
}

const FeatureTopicsModeratorTagsWithHelp = () => <div className='widget-configuration_info-box'>
    <strong>✨ How to feature topics in this widget </strong>
    <p>Open a topic in control and add the moderator tag ‘featured_home’ to feature it on the homepage.</p>
  </div>

export default FeatureTopicsModeratorTagsWithHelp
